import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	ISSUE_FIELD_STRING_CF_TYPE,
	URL_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggUrlToLegacyField: FieldTransformer<typeof URL_CF_TYPE> = (node) => {
	if (node.type !== URL_CF_TYPE) return undefined;
	return {
		...transformAggNodeToLegacyField(node),
		value: node.uri ?? null,
		schema: {
			configuration: null,
			custom: URL_CF_TYPE,
			items: null,
			renderer: PLAIN_TEXT,
			system: null,
			type: ISSUE_FIELD_STRING_CF_TYPE,
		},
	};
};
